/** Routes for the X-Translator user manual inside the SEPM docs site. */
export const MANUAL_HOME = "/docs/x-translator";

export function manualPagePath(pageId: string, hash?: string) {
  const path = `${MANUAL_HOME}/${pageId}`;
  return hash ? `${path}#${hash}` : path;
}
